// removed by extract-text-webpack-plugin
module.exports = {"menu_open":"menu_open___1K2pg"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/app.module.scss
// module id = 2047
// module chunks = 0